angular.module('clients')
    .controller('ClientDialogController', function ($rootScope, $uibModalInstance, $timeout, data, toastr, modals, Client, ClientConst, PaymentMethod, PaymentDeadline, Country, GusService, ViesService, PhoneNumberFormatter) {

        this.$onInit = () => {
            this.item = data
            this.bankAccountTypes = ['CURRENT', 'VAT', 'RWW', 'OTHER']
            PaymentMethod.query().$promise.then(items => this.paymentMethods = items)
            PaymentDeadline.query().$promise.then(items => this.paymentDeadlines = items)
            Country.list().$promise.then(page => this.countries = page.list)
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled')

        this.chooseClientDuplicate = (clients) => {
            return modals.open('app/clients/duplicates-modal.html', 'ClientDialogDuplicatesController', clients, {size: 'md'}, "$ctrl")
        }

        this.save = () => {
            let promise;
            this.isSaving = true
            const payload = this.prepareClientForSave(this.item)
            if (this.item.id !== null) {
                promise = this.updateRequest(payload)
            } else {
                promise = Client.duplicationCheck(payload).$promise
                    .then(duplicates => {
                        if (duplicates.length > 0) {
                            return this.chooseClientDuplicate(duplicates)
                                .then(client => {
                                    if(client != null){
                                       return this.loadRequest(client.id)
                                    }
                                    else {
                                        return this.saveRequest(payload)
                                    }
                                })
                        } else {
                            return this.saveRequest(payload)
                        }
                    })
            }

            return promise
                .then(result => {
                    $uibModalInstance.close(result)
                })
                .finally(() => {
                    this.isSaving = false
                })
        }

        this.updateRequest = (client) => {
            return Client.update(client).$promise
                .then(result => {
                    $rootScope.$broadcast(ClientConst.eventUpdate)
                    toastr.success("Zapisano")
                    return result
                })
        }

        this.loadRequest = (id) => {
            return Client.get({id: id}).$promise
                .then(result => {
                    toastr.success("Wybrano kontrahenta z bazy danych")
                    return result
                })
        }

        this.saveRequest = (client) => {
            return Client.save(client).$promise
                .then(result => {
                    $rootScope.$broadcast(ClientConst.eventUpdate)
                    toastr.success("Zapisano")
                    return result
                })
        }

        this.gusUpdate = () => {
            this.isSaving = true
            GusService.search(this.item.nip)
                .then(gus => {
                    toastr.success("Załadowano dane z: " + gus.details.nazwa)
                    let nipToOverride = gus.nip
                    if (this.item.nip.length > 2 && this.item.nip.substring(0, 2) === "PL") {
                        nipToOverride = this.item.nip.substring(0, 2) + nipToOverride
                    }
                    this.item.nip = nipToOverride
                    if (this.item.symbol == null || this.item.symbol.length === 0) {
                        this.item.symbol = gus.details.nazwaSkrocona!=null? gus.details.nazwaSkrocona.toUpperCase():null
                    }
                    this.item.fullName = gus.details.nazwa
                    this.item.address = gus.details.adres
                    this.item.postcode = gus.details.kodPocztowy
                    this.item.city = gus.details.miasto
                    this.item.regon = gus.details.regon
                    this.item.country = this.countries.find(c => c.name === 'Polska')
                    this.item.countryRegion = this.item.country.regions.find(r => r.name === gus.details.wojewodztwo)
                    this.addContactIfMissing('PHONE', gus.details.numerTelefonu, 'Telefon z GUS')
                    this.addContactIfMissing('EMAIL', gus.details.email, 'Email z GUS')
                    this.addContactIfMissing('WEBSITE', gus.details.stronaInternetowa, 'WWW z GUS')
                })
                .finally(() => this.isSaving = false)
        }

        this.viesUpdate = () => {
            const originalVatNumber = this.item.nip
            this.isSaving = true
            ViesService.check(this.item.nip, this.getViesCountryCode())
                .then(vies => {
                    this.applyViesResult(vies, originalVatNumber)
                    toastr.success('Zastosowano dane zweryfikowane w VIES')
                })
                .finally(() => this.isSaving = false)
        }

        this.getViesCountryCode = () => {
            const countryCode = this.item.country && this.item.country.code
                ? this.item.country.code.toUpperCase()
                : 'PL'
            const aliases = {
                GR: 'EL',
                HL: 'NL',
                LI: 'LT'
            }
            return aliases[countryCode] || countryCode
        }

        this.applyViesResult = (vies, originalVatNumber) => {
            this.item.nip = this.formatViesVatNumber(vies, originalVatNumber)
            if (this.normalizeText(vies.name)) {
                this.item.fullName = this.normalizeText(vies.name)
            }
            if (this.normalizeText(vies.address)) {
                this.item.address = this.normalizeText(vies.address)
                this.item.postcode = this.normalizeText(vies.postcode) || null
                this.item.city = this.normalizeText(vies.city) || null
            }

            const country = this.findCountryForViesCode(vies.countryCode)
            if (country) {
                const countryChanged = !this.item.country || this.item.country.id !== country.id
                this.item.country = country
                if (countryChanged) {
                    this.item.countryRegion = null
                }
            }
        }

        this.formatViesVatNumber = (vies, originalVatNumber) => {
            const normalizedOriginal = this.normalizeText(originalVatNumber)
                .toUpperCase()
                .replace(/[\s./-]/g, '')
            const hadCountryPrefix = /^[A-Z]{2}/.test(normalizedOriginal)
            return hadCountryPrefix || vies.countryCode !== 'PL'
                ? `${vies.countryCode}${vies.vatNumber}`
                : vies.vatNumber
        }

        this.findCountryForViesCode = viesCountryCode => {
            const aliases = {
                EL: ['EL', 'GR'],
                LT: ['LT', 'LI'],
                NL: ['NL', 'HL']
            }
            const countryCodes = aliases[viesCountryCode] || [viesCountryCode]
            return (this.countries || []).find(country => {
                const code = this.normalizeText(country.code).toUpperCase()
                return countryCodes.includes(code)
            })
        }

        this.onDefaultContactChange = contact => {
            this.item.contacts.filter(v => v !== contact).forEach(value => value.defaults = false)
        }
        this.onDefaultAddressChange = address => {
            this.item.addresses.filter(v => v !== address).forEach(value => value.defaults = false)
        }
        this.removeBankAccount = index => {
            this.item.bankAccounts.splice(index, 1)
        }
        this.addBankAccount = () => {
            this.item.bankAccounts.push({})
        }
        this.addContact = () => {
            this.item.contacts.push({active: true, defaults: false, type: 'OTHER'})
            const index = this.item.contacts.length - 1
            $timeout(() => {
                const element = document.getElementById(`contact-value-text-${index}`)
                    || document.getElementById(`contact-value-email-${index}`)
                    || document.getElementById(`contact-value-phone-${index}`)
                if (element && angular.isFunction(element.focus)) {
                    element.focus()
                    if (angular.isFunction(element.select)) {
                        element.select()
                    }
                }
            })
        }
        this.removeContact = contact => {
            const index = this.item.contacts.indexOf(contact)
            if (index >= 0) {
                this.item.contacts.splice(index, 1)
            }
        }
        this.addContactIfMissing = (type, value, name) => {
            value = this.normalizeText(value)
            if (!value) {
                return
            }
            this.item.contacts = this.item.contacts || []
            const normalizedValue = type === 'EMAIL' ? value.toLowerCase() : value.replace(/\s/g, '')
            const exists = this.item.contacts.some(contact => contact && contact.type === type && this.normalizeContactValue(contact.value, type) === normalizedValue)
            if (!exists) {
                this.item.contacts.push({active: true, defaults: false, type: type, value: value, name: name})
            }
        }
        this.onPrimaryBankAccountChange = bankAccount => {
            this.item.bankAccounts.filter(v => v !== bankAccount).forEach(value => value.primary = false)
        }

        this.normalizeText = value => (typeof value === 'string' ? value.trim() : '')

        this.normalizeContactType = value => {
            const normalized = this.normalizeText(value).toUpperCase()
            return ['PHONE', 'EMAIL', 'WEBSITE', 'OTHER'].includes(normalized) ? normalized : 'OTHER'
        }

        this.normalizeContactValue = (value, type) => {
            value = this.normalizeText(value)
            if (type === 'EMAIL') {
                return value.toLowerCase()
            }
            if (type === 'PHONE' || type === 'WEBSITE') {
                return value.replace(/\s/g, '')
            }
            return value
        }

        this.detectContactType = rawValue => {
            const value = this.normalizeText(rawValue)
            if (!value) {
                return 'OTHER'
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
            if (emailRegex.test(value)) {
                return 'EMAIL'
            }

            if (value.indexOf('http://') === 0 || value.indexOf('https://') === 0 || /^www\./i.test(value)) {
                return 'WEBSITE'
            }

            if (PhoneNumberFormatter && angular.isFunction(PhoneNumberFormatter.isAcceptableNumber) && PhoneNumberFormatter.isAcceptableNumber(value, 'PL')) {
                return 'PHONE'
            }

            const compact = value.replace(/[.\s()/-]/g, '')
            const compactNormalized = compact.indexOf('00') === 0 ? `+${compact.slice(2)}` : compact
            if (/^\+?\d+$/.test(compactNormalized)) {
                const digits = compactNormalized.replace(/^\+/, '')
                if (digits.length >= 7) {
                    return 'PHONE'
                }
            }

            return 'OTHER'
        }

        this.inferContactTypeOnBlur = contact => {
            if (!contact) {
                return
            }
            const value = this.normalizeText(contact.value)
            const currentType = this.normalizeContactType(contact.type)
            // Auto-detection is only a helper for new/unspecified contacts.
            // If user explicitly selected a type, don't override it on blur.
            if (currentType !== 'OTHER') {
                return
            }
            contact.type = this.detectContactType(value)
        }

        this.prepareClientForSave = client => {
            const payload = angular.copy(client || {})
            payload.contacts = this.normalizeContacts(payload.contacts || [])
            return payload
        }

        this.normalizeContacts = contacts => {
            const normalized = []
            ;(contacts || []).forEach(contact => {
                if (!contact) {
                    return
                }
                const base = angular.copy(contact)
                const name = this.normalizeText(contact.name)
                const type = this.normalizeContactType(contact.type || this.detectContactType(contact.value))
                const value = this.normalizeContactValue(contact.value, type)
                if (!name && !value) {
                    return
                }

                base.name = name || null
                base.type = this.normalizeContactType(type || this.detectContactType(value))
                base.value = value || null
                delete base.phone1
                delete base.email
                normalized.push(base)
            })

            let defaultAssigned = false
            normalized.forEach(contact => {
                if (contact.defaults && !defaultAssigned) {
                    defaultAssigned = true
                    return
                }
                contact.defaults = false
            })

            return normalized
        }
    })
